module.exports = __webpack_public_path__ + "img/ez-slot-ic_lobby_mobile.e09f09df.png";